module.exports = __webpack_public_path__ + "assets/img/02.aof-rewrite.bacad493.png";